<template>
  <div>
    <HeaderComponent/>
  
  <!-- Section de chargement -->
  <section v-if="loading" class="w-full min-h-screen flex items-center justify-center">
    <div class="container lg:max-w-[1200px] flex items-center justify-center py-20 px-[20px]">
      <div class="text-center">
        <div class="animate-spin rounded-full h-16 w-16 border-b-2 border-[#D4AF37] mx-auto mb-4"></div>
        <p class="text-gray-600">Chargement des détails du bien...</p>
      </div>
    </div>
  </section>

  <!-- Section d'erreur -->
  <section v-else-if="!apartment || Object.keys(apartment).length === 0" class="w-full min-h-screen flex items-center justify-center">
    <div class="container lg:max-w-[1200px] flex items-center justify-center py-20 px-[20px]">
      <div class="text-center max-w-md">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-24 w-24 text-gray-400 mx-auto mb-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <h2 class="text-2xl font-bold text-gray-800 mb-4">Bien non trouvé</h2>
        <p class="text-gray-600 mb-8">
          Désolé, l'appartement, la villa ou le bien que vous recherchez n'existe pas ou n'est plus disponible.
        </p>
        <button 
          @click="goBack"
          class="px-6 py-3 bg-[#D4AF37] text-white rounded-lg font-semibold hover:bg-amber-600 transition duration-200"
        >
          Retour à l'accueil
        </button>
      </div>
    </div>
  </section>

  <!-- Section principale quand l'appartement existe -->
  <section v-else class="w-full relative flex items-center justify-center lg:h-[650px] h-[400px] pt-[90px]">
    <!-- Bouton retour -->
    
    <div class="container lg:max-w-[1200px] flex md:flex-row flex-col w-full h-full justify-center items-center relative px-[20px]">
      <div class="w-full h-full bg-gray-100 flex items-center justify-center relative rounded-[20px] overflow-hidden">
        <img v-if="apartmentImages.length" 
          :src="'https://api.mohimmo.com/uploads/'+apartmentImages[0]" 
          :alt="apartment?.title"
          class="w-full h-full absolute object-cover object-center"
        >
        <div v-else class="w-full h-full bg-gray-200 flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
        <div class="degradeB"></div>
        <button
          @click="goBack"
          class="absolute md:top-5 top-3 left-3 md:left-5 z-10 flex items-center gap-2 px-4 py-2 bg-white/90 backdrop-blur-sm text-gray-700 rounded-full shadow-md hover:bg-white hover:shadow-lg transition-all duration-200"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
          <span class="text-sm font-medium">Retour</span>
        </button>
        <button
          @click="shareApartment"
          class="absolute md:top-5 top-3 right-3 md:right-5 z-10 flex items-center gap-2 px-4 py-2 bg-white/90 backdrop-blur-sm text-gray-700 rounded-full shadow-md hover:bg-white hover:shadow-lg transition-all duration-200 group"
          title="Partager ce bien"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" class="group-hover:scale-110 transition-transform">
            <circle cx="18" cy="5" r="1" fill="currentColor" opacity=".3"/>
            <circle cx="6" cy="12" r="1" fill="currentColor" opacity=".3"/>
            <circle cx="18" cy="19.02" r="1" fill="currentColor" opacity=".3"/>
            <path fill="currentColor" d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81c1.66 0 3-1.34 3-3s-1.34-3-3-3s-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65c0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92M18 4c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1M6 13c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1m12 7.02c-.55 0-1-.45-1-1s.45-1 1-1s1 .45 1 1s-.45 1-1 1"/>
          </svg>
          <span class="text-sm font-medium">Partager</span>
        </button>
        <div 
          v-if="apartmentImages.length"
          class="w-[200px] h-[100px] flex items-center justify-center p-[45px] rounded-[10px] bg-black/30 absolute right-[10px] bottom-[10px] backdrop-blur-md cursor-pointer"
          @click="showAllPhotos = true"
        >
          <button class="text-sm font-bold text-white text-center">
            Voir toutes les {{ apartmentImages.length }} Photos
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- Modal pour afficher toutes les photos -->
  <div v-if="showAllPhotos && apartmentImages.length" class="fixed inset-0 bg-black z-50">
    <!-- Image plein écran -->
    <div
      class="absolute inset-0 flex items-center justify-center select-none"
      @touchstart="onTouchStart"
      @touchend="onTouchEnd"
    >
      <img
        :src="`https://api.mohimmo.com/uploads/${apartmentImages[currentPhotoIndex]}`"
        class="max-w-full max-h-full w-auto h-auto object-contain pointer-events-none"
        :alt="`Photo ${currentPhotoIndex + 1} de ${apartment?.title}`"
      >
    </div>

    <!-- Barre du haut (au-dessus de l'image, semi-transparente) -->
    <div class="absolute top-0 left-0 right-0 z-20 flex items-center justify-end gap-2 px-4 pt-4 pb-8 bg-gradient-to-b from-black/70 via-black/40 to-transparent">
      <button
        class="text-white bg-black/50 hover:bg-black/80 rounded-full p-2 transition-colors"
        @click="downloadCurrentPhoto"
        title="Télécharger l'image"
        aria-label="Télécharger l'image"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="currentColor" d="M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"/>
        </svg>
      </button>
      <button
        class="text-white bg-black/50 hover:bg-black/80 rounded-full p-2 transition-colors"
        @click="showAllPhotos = false"
        title="Fermer"
        aria-label="Fermer"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41z"/>
        </svg>
      </button>
    </div>

    <!-- Barre du bas (au-dessus de l'image, semi-transparente) -->
    <div class="absolute bottom-0 left-0 right-0 z-20 flex items-center justify-center gap-2 px-4 pb-6 pt-10 bg-gradient-to-t from-black/70 via-black/40 to-transparent">
      <button
        @click="prevPhoto"
        class="p-2 rounded-full bg-black/50 text-white disabled:opacity-50 hidden md:flex"
        :disabled="currentPhotoIndex === 0"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="currentColor" d="M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6l6 6l1.41-1.42z"/>
        </svg>
      </button>

      <div class="flex gap-1.5">
        <button
          v-for="(img, index) in apartmentImages"
          :key="index"
          @click="currentPhotoIndex = index"
          class="w-2.5 h-2.5 rounded-full transition-colors"
          :class="{'bg-[#D4AF37]': currentPhotoIndex === index, 'bg-white/50': currentPhotoIndex !== index}"
        ></button>
      </div>

      <button
        @click="nextPhoto"
        class="p-2 rounded-full bg-black/50 text-white disabled:opacity-50 hidden md:flex"
        :disabled="currentPhotoIndex === apartmentImages.length - 1"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="currentColor" d="M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Contenu principal de l'appartement -->
  <section v-if="apartment && Object.keys(apartment).length > 0" class="w-full py-[25px] flex items-center justify-center relative">
    <div class="container w-full lg:max-w-[1200px] md:flex-row flex-col flex items-start justify-center relative px-[20px]">
      <div class="md:w-[calc(100%-400px)] w-full md:pr-[25px] relative">
        <div class="w-full flex items-start flex-wrap justify-between relative">
          <div class="flex flex-col">
            <h2 class="text-3xl font-bold text-gray-800">
              {{ apartment?.title }}
            </h2>
            <h3 class="flex items-center text-gray-600">
              <svg class="mr-[5px]" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
                <path fill="currentColor" d="M12 21.325q-.35 0-.7-.125t-.625-.375Q9.05 19.325 7.8 17.9t-2.087-2.762t-1.275-2.575T4 10.2q0-3.75 2.413-5.975T12 2t5.588 2.225T20 10.2q0 1.125-.437 2.363t-1.275 2.575T16.2 17.9t-2.875 2.925q-.275.25-.625.375t-.7.125M12 12q.825 0 1.413-.587T14 10t-.587-1.412T12 8t-1.412.588T10 10t.588 1.413T12 12"/>
              </svg>
              {{ apartment?.locality }}, {{ apartment?.country }}
            </h3>
          </div>
          <div class="flex items-center">
            <span class="text-2xl font-bold text-gray-800">{{ apartment?.rating || '4.5' }}</span>
            <div class="text-[#D4AF37] flex items-center mt-[-5px]">
              <svg v-for="i in 5" :key="i" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                <path 
                  fill="currentColor" 
                  :d="i <= Math.floor(apartment?.rating || 4.5) 
                    ? 'm12 17.27l4.15 2.51c.76.46 1.69-.22 1.49-1.08l-1.1-4.72l3.67-3.18c.67-.58.31-1.68-.57-1.75l-4.83-.41l-1.89-4.46c-.34-.81-1.5-.81-1.84 0L9.19 8.63l-4.83.41c-.88.07-1.24 1.17-.57 1.75l3.67 3.18l-1.1 4.72c-.2.86.73 1.54 1.49 1.08z'
                    : 'm19.65 9.04l-4.84-.42l-1.89-4.45c-.34-.81-1.5-.81-1.84 0L9.19 8.63l-4.83.41c-.88.07-1.24 1.17-.57 1.75l3.67 3.18l-1.1 4.72c-.2.86.73 1.54 1.49 1.08l4.15-2.5l4.15 2.51c.76.46 1.69-.22 1.49-1.08l-1.1-4.73l3.67-3.18c.67-.58.32-1.68-.56-1.75M12 15.4V6.1l1.71 4.04l4.38.38l-3.32 2.88l1 4.28z'"
                />
              </svg>
            </div>
          </div>
        </div>
        <p class="text-base text-gray-600 my-[25px]">
          <span class="text-sm font-bold text-gray-800">Description :</span> {{ apartment?.description || 'Aucune description disponible.' }}
        </p>
        
        <div class="w-full relative flex items-center justify-start overflow-x-auto parent gap-[20px]">
          <div
            v-for="(image, index) in apartmentImages"
            :key="index"
            class="w-[150px] h-[150px] min-w-[150px] min-h-[150px] rounded-[20px] flex relative justify-center items-center overflow-hidden cursor-pointer group"
            @click="showPhoto(index)"
          >
            <img
              :src="`https://api.mohimmo.com/uploads/${image}`"
              :alt="`Photo ${index + 1} de ${apartment?.title}`"
              class="w-full h-full absolute object-cover object-center hover:scale-110 transition-transform duration-300"
            >
            <button
              @click.stop="downloadPhoto(index)"
              class="absolute top-2 right-2 z-10 w-8 h-8 rounded-full bg-black/60 text-white flex items-center justify-center md:opacity-0 md:group-hover:opacity-100 transition-opacity hover:bg-black/80"
              title="Télécharger l'image"
              aria-label="Télécharger l'image"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                <path fill="currentColor" d="M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
      
      <div class="md:w-[400px] md:min-w-[400px] w-full mt-[25px] md:mt-0 min-h-[470px] rounded-[20px] p-[20px] shadow-4xl">
        <h3 class="text-sm font-bold text-gray-800">
          Informations clés
        </h3>
        <p class="text-base text-gray-600 my-[20px]">
          Caractéristiques du logement
        </p>
        
        <div class="grid grid-cols-1 gap-4">
          <div v-if="activeHousingFeatures.length === 0" class="bg-gray-100 p-4 rounded-lg text-sm text-gray-600 text-center font-medium">
            Aucune caractéristique disponible
          </div>

          <div
            v-for="(row, rowIndex) in featureRows"
            :key="`feature-row-${rowIndex}`"
            class="bg-gray-100 p-4 rounded-lg grid grid-cols-3 gap-4"
          >
            <div
              v-for="feature in row"
              :key="feature.key"
              class="flex flex-col items-center justify-center"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                <path fill="currentColor" :d="feature.icon"/>
              </svg>
              <span class="text-sm text-center font-semibold text-gray-700 mt-1">
                {{ feature.label }}
              </span>
            </div>

            <div
              v-for="placeholder in (3 - row.length)"
              :key="`placeholder-${rowIndex}-${placeholder}`"
              class="invisible"
            ></div>
          </div>
        </div>

        <div v-if="apartment?.category === 'achat'" class="w-full flex items-center justify-center my-[40px]">
          <div class="w-full flex items-center justify-center flex-col px-[25px]">
            <h4 class="text-sm font-semibold text-gray-700">Prix de vente</h4>
            <span class="text-[8px] text-gray-600 text-center">
              (Prix fixe pour l'acquisition du bien)
            </span>
            <p class="flex flex-col text-sm font-bold text-gray-800 mt-[20px] justify-center items-center">
              <span class="text-xl">{{ formatPrice(apartment?.salePrice || apartment?.price) }}</span>
              <span>FCFA</span>
            </p>
          </div>
        </div>
        
        <div v-else class="w-full grid grid-cols-3 gap-2 my-[30px]">
          <!-- Court séjour - par nuitée -->
          <div class="border rounded-lg p-3 flex items-center justify-center flex-col">
            <h4 class="text-xs font-semibold text-gray-700">Court séjour</h4>
            <span class="text-[8px] text-gray-500">(nuitée)</span>
            <p class="flex flex-col text-sm font-bold text-gray-800 mt-2 justify-center items-center">
              <span class="text-base text-[#D4AF37]">{{ formatPrice(apartment?.shortStayPrice) }}</span>
              <span class="text-[10px] text-gray-500">FCFA</span>
            </p>
          </div>
          
          <!-- Prix semaine -->
          <div class="border rounded-lg p-3 flex items-center justify-center flex-col">
            <h4 class="text-xs font-semibold text-gray-700">Semaine</h4>
            <span class="text-[8px] text-gray-500">(7 jours)</span>
            <template v-if="apartment?.weeklyPrice">
              <div class="mt-2 text-center">
                <span class="text-[9px] text-gray-400 line-through">{{ formatPrice(apartment.weeklyPrice) }}</span>
                <span class="text-[8px] text-green-600 ml-1">+10%</span>
              </div>
              <span class="text-base text-[#D4AF37] font-bold">{{ formatPrice(Math.round(apartment.weeklyPrice * 1.10)) }}</span>
              <span class="text-[10px] text-gray-500">FCFA TTC</span>
            </template>
            <template v-else>
              <span class="text-xs text-gray-400 mt-2">Non défini</span>
            </template>
          </div>
          
          <!-- Prix du mois -->
          <div class="border rounded-lg p-3 flex items-center justify-center flex-col">
            <h4 class="text-xs font-semibold text-gray-700">Mois</h4>
            <span class="text-[8px] text-gray-500">(30 jours)</span>
            <template v-if="apartment?.longStayPrice">
              <div class="mt-2 text-center">
                <span class="text-[9px] text-gray-400 line-through">{{ formatPrice(apartment.longStayPrice) }}</span>
                <span class="text-[8px] text-green-600 ml-1">+10%</span>
              </div>
              <span class="text-base text-[#D4AF37] font-bold">{{ formatPrice(Math.round(apartment.longStayPrice * 1.10)) }}</span>
              <span class="text-[10px] text-gray-500">FCFA TTC</span>
            </template>
            <template v-else>
              <span class="text-xs text-gray-400 mt-2">Non défini</span>
            </template>
          </div>
        </div>

        <div v-if="apartment?.category === 'achat'" class="w-full flex items-center relative justify-between">
          <a target="_blank" href="tel:+2290156581203" class="w-[calc(50%-10px)] h-[40px] rounded-[5px] bg-gray-100 flex items-center justify-center text-gray-800 font-bold">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.6 14.522c-2.395 2.52-8.504-3.534-6.1-6.064c1.468-1.545-.19-3.31-1.108-4.609c-1.723-2.435-5.504.927-5.39 3.066c.363 6.746 7.66 14.74 14.726 14.042c2.21-.218 4.75-4.21 2.215-5.669c-1.268-.73-3.009-2.17-4.343-.767"/>
            </svg>
          </a>
          <a target="_blank" href="https://wa.me/+2290156581203" class="w-[calc(50%-10px)] h-[40px] rounded-[5px] bg-gray-100 flex items-center justify-center text-gray-800 font-bold">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
              <g fill="none">
                <path fill="currentColor" d="m13.087 21.388l.645.382zm.542-.916l-.646-.382zm-3.258 0l-.645.382zm.542.916l.646-.382zM1.25 10.5a.75.75 0 0 0 1.5 0zm1.824 5.126a.75.75 0 0 0-1.386.574zm4.716 3.365l-.013.75zm-2.703-.372l-.287.693zm16.532-2.706l.693.287zm-5.409 3.078l-.012-.75zm2.703-.372l.287.693zm.7-15.882l-.392.64zm1.65 1.65l.64-.391zM4.388 2.738l-.392-.64zm-1.651 1.65l-.64-.391zM9.403 19.21l.377-.649zm4.33 2.56l.541-.916l-1.29-.764l-.543.916zm-4.007-.916l.542.916l1.29-.764l-.541-.916zm2.715.152a.52.52 0 0 1-.882 0l-1.291.764c.773 1.307 2.69 1.307 3.464 0zM10.5 2.75h3v-1.5h-3zm10.75 7.75v1h1.5v-1zM7.803 18.242c-1.256-.022-1.914-.102-2.43-.316L4.8 19.313c.805.334 1.721.408 2.977.43zM1.688 16.2A5.75 5.75 0 0 0 4.8 19.312l.574-1.386a4.25 4.25 0 0 1-2.3-2.3zm19.562-4.7c0 1.175 0 2.019-.046 2.685c-.045.659-.131 1.089-.277 1.441l1.385.574c.235-.566.338-1.178.389-1.913c.05-.729.049-1.632.049-2.787zm-5.027 8.241c1.256-.021 2.172-.095 2.977-.429l-.574-1.386c-.515.214-1.173.294-2.428.316zm4.704-4.115a4.25 4.25 0 0 1-2.3 2.3l.573 1.386a5.75 5.75 0 0 0 3.112-3.112zM13.5 2.75c1.651 0 2.837 0 3.762.089c.914.087 1.495.253 1.959.537l.783-1.279c-.739-.452-1.577-.654-2.6-.752c-1.012-.096-2.282-.095-3.904-.095zm9.25 7.75c0-1.622 0-2.891-.096-3.904c-.097-1.023-.299-1.862-.751-2.6l-1.28.783c.285.464.451 1.045.538 1.96c.088.924.089 2.11.089 3.761zm-3.53-7.124a4.25 4.25 0 0 1 1.404 1.403l1.279-.783a5.75 5.75 0 0 0-1.899-1.899zM10.5 1.25c-1.622 0-2.891 0-3.904.095c-1.023.098-1.862.3-2.6.752l.783 1.28c.464-.285 1.045-.451 1.96-.538c.924-.088 2.11-.089 3.761-.089zM2.75 10.5c0-1.651 0-2.837.089-3.762c.087-.914.253-1.495.537-1.959l-1.279-.783c-.452.738-.654 1.577-.752 2.6C1.25 7.61 1.25 8.878 1.25 10.5zm1.246-8.403a5.75 5.75 0 0 0-1.899 1.899l1.28.783a4.25 4.25 0 0 1 1.402-1.403zm7.02 17.993c-.202-.343-.38-.646-.554-.884a2.2 2.2 0 0 0-.682-.645l-.754 1.297c.047.028.112.078.224.232c.121.166.258.396.476.764zm-3.24-.349c.44.008.718.014.93.037c.198.022.275.054.32.08l.754-1.297a2.2 2.2 0 0 0-.909-.274c-.298-.033-.657-.038-1.069-.045zm6.498 1.113c.218-.367.355-.598.476-.764c.112-.154.177-.204.224-.232l-.754-1.297c-.29.17-.5.395-.682.645c-.173.238-.352.54-.555.884zm1.924-2.612c-.412.007-.771.012-1.069.045c-.311.035-.616.104-.909.274l.754 1.297c.045-.026.122-.058.32-.08c.212-.023.49-.03.93-.037z"/>
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 11h.009m3.982 0H12m3.991 0H16"/>
              </g>
            </svg>
          </a>
        </div>
        <div v-else class="w-full flex items-center relative justify-between">
          <button 
            class="w-[calc(100%-120px)] h-[40px] rounded-[5px] bg-[#D4AF37] text-sm flex items-center justify-center text-white duration-200 hover:text-gray-800 font-bold"
            @click="rentApartment"
          >
            Réserver
          </button>
          <a target="_blank" href="tel:+2290156581203" class="w-[40px] h-[40px] rounded-[5px] bg-gray-100 flex items-center justify-center text-gray-800 font-bold">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.6 14.522c-2.395 2.52-8.504-3.534-6.1-6.064c1.468-1.545-.19-3.31-1.108-4.609c-1.723-2.435-5.504.927-5.39 3.066c.363 6.746 7.66 14.74 14.726 14.042c2.21-.218 4.75-4.21 2.215-5.669c-1.268-.73-3.009-2.17-4.343-.767"/>
            </svg>
          </a>
          <a target="_blank" href="https://wa.me/+2290156581203" class="w-[40px] h-[40px] rounded-[5px] bg-gray-100 flex items-center justify-center text-gray-800 font-bold">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
              <g fill="none">
                <path fill="currentColor" d="m13.087 21.388l.645.382zm.542-.916l-.646-.382zm-3.258 0l-.645.382zm.542.916l.646-.382zM1.25 10.5a.75.75 0 0 0 1.5 0zm1.824 5.126a.75.75 0 0 0-1.386.574zm4.716 3.365l-.013.75zm-2.703-.372l-.287.693zm16.532-2.706l.693.287zm-5.409 3.078l-.012-.75zm2.703-.372l.287.693zm.7-15.882l-.392.64zm1.65 1.65l.64-.391zM4.388 2.738l-.392-.64zm-1.651 1.65l-.64-.391zM9.403 19.21l.377-.649zm4.33 2.56l.541-.916l-1.29-.764l-.543.916zm-4.007-.916l.542.916l1.29-.764l-.541-.916zm2.715.152a.52.52 0 0 1-.882 0l-1.291.764c.773 1.307 2.69 1.307 3.464 0zM10.5 2.75h3v-1.5h-3zm10.75 7.75v1h1.5v-1zM7.803 18.242c-1.256-.022-1.914-.102-2.43-.316L4.8 19.313c.805.334 1.721.408 2.977.43zM1.688 16.2A5.75 5.75 0 0 0 4.8 19.312l.574-1.386a4.25 4.25 0 0 1-2.3-2.3zm19.562-4.7c0 1.175 0 2.019-.046 2.685c-.045.659-.131 1.089-.277 1.441l1.385.574c.235-.566.338-1.178.389-1.913c.05-.729.049-1.632.049-2.787zm-5.027 8.241c1.256-.021 2.172-.095 2.977-.429l-.574-1.386c-.515.214-1.173.294-2.428.316zm4.704-4.115a4.25 4.25 0 0 1-2.3 2.3l.573 1.386a5.75 5.75 0 0 0 3.112-3.112zM13.5 2.75c1.651 0 2.837 0 3.762.089c.914.087 1.495.253 1.959.537l.783-1.279c-.739-.452-1.577-.654-2.6-.752c-1.012-.096-2.282-.095-3.904-.095zm9.25 7.75c0-1.622 0-2.891-.096-3.904c-.097-1.023-.299-1.862-.751-2.6l-1.28.783c.285.464.451 1.045.538 1.96c.088.924.089 2.11.089 3.761zm-3.53-7.124a4.25 4.25 0 0 1 1.404 1.403l1.279-.783a5.75 5.75 0 0 0-1.899-1.899zM10.5 1.25c-1.622 0-2.891 0-3.904.095c-1.023.098-1.862.3-2.6.752l.783 1.28c.464-.285 1.045-.451 1.96-.538c.924-.088 2.11-.089 3.761-.089zM2.75 10.5c0-1.651 0-2.837.089-3.762c.087-.914.253-1.495.537-1.959l-1.279-.783c-.452.738-.654 1.577-.752 2.6C1.25 7.61 1.25 8.878 1.25 10.5zm1.246-8.403a5.75 5.75 0 0 0-1.899 1.899l1.28.783a4.25 4.25 0 0 1 1.402-1.403zm7.02 17.993c-.202-.343-.38-.646-.554-.884a2.2 2.2 0 0 0-.682-.645l-.754 1.297c.047.028.112.078.224.232c.121.166.258.396.476.764zm-3.24-.349c.44.008.718.014.93.037c.198.022.275.054.32.08l.754-1.297a2.2 2.2 0 0 0-.909-.274c-.298-.033-.657-.038-1.069-.045zm6.498 1.113c.218-.367.355-.598.476-.764c.112-.154.177-.204.224-.232l-.754-1.297c-.29.17-.5.395-.682.645c-.173.238-.352.54-.555.884zm1.924-2.612c-.412.007-.771.012-1.069.045c-.311.035-.616.104-.909.274l.754 1.297c.045-.026.122-.058.32-.08c.212-.023.49-.03.93-.037z"/>
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 11h.009m3.982 0H12m3.991 0H16"/>
              </g>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </section>
  <FooterComponent/>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
import HeaderComponent from '@/components/HeaderComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import apiClient from '@/services/api'
import { downloadImage } from '@/services/downloadImage'
import { toast } from 'vue3-toastify'

const router = useRouter()
const route = useRoute();
const apartment = ref({});
const loading = ref(true);
const showAllPhotos = ref(false);
const currentPhotoIndex = ref(0);
const apartmentImages = computed(() => Array.isArray(apartment.value?.images) ? apartment.value.images : []);

const FEATURE_CONFIG = [
  { key: 'wifi', label: 'WiFi', icon: 'M12 21q-1.05 0-1.775-.725T9.5 18.5t.725-1.775T12 16t1.775.725t.725 1.775t-.725 1.775T12 21m-5.65-5.65l-2.1-2.15q1.475-1.475 3.463-2.337T12 10t4.288.875t3.462 2.375l-2.1 2.1q-1.1-1.1-2.55-1.725T12 13t-3.1.625t-2.55 1.725M2.1 11.1L0 9q2.3-2.35 5.375-3.675T12 4t6.625 1.325T24 9l-2.1 2.1q-1.925-1.925-4.462-3.012T12 7T6.563 8.088T2.1 11.1' },
  { key: 'privateEntrance', label: 'Entrée personnelle', icon: 'M18.9 6c-.2-.6-.8-1-1.4-1h-11c-.7 0-1.2.4-1.4 1L3 12v8c0 .5.5 1 1 1h1c.6 0 1-.5 1-1v-1h12v1c0 .5.5 1 1 1h1c.5 0 1-.5 1-1v-8zM6.8 7h10.3l1.1 3H5.8zM19 17H5v-5h14zM7.5 13c.8 0 1.5.7 1.5 1.5S8.3 16 7.5 16S6 15.3 6 14.5S6.7 13 7.5 13m9 0c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5' },
  { key: 'security', label: 'Sécurité', icon: 'M20.872 5.05a2.82 2.82 0 0 0-1.402-1.026l-4.801-1.6a8.68 8.68 0 0 0-5.357 0l-4.8 1.6A2.82 2.82 0 0 0 3.117 5.05a2.82 2.82 0 0 0-.536 1.657v5.158a8.47 8.47 0 0 0 3.972 7.22l3.954 2.486a2.82 2.82 0 0 0 2.993 0l3.954-2.485a8.47 8.47 0 0 0 3.963-7.174V6.754a2.82 2.82 0 0 0-.546-1.704m-7.935 7.286v2.269a.941.941 0 0 1-1.883 0v-2.269a2.984 2.984 0 1 1 1.883 0' },
  { key: 'terrace', label: 'Terrasse', icon: 'M12 4L2 9l10 5l10-5zm-8 8v5l8 4l8-4v-5l-8 4z' },
  { key: 'smokerFriendly', label: 'Fumeur accepté', icon: 'M13.5 8.875h-1.875v5H13.5a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5m-12 5h8.875v-5H1.5a1.5 1.5 0 0 0-1.5 1.5v2a1.5 1.5 0 0 0 1.5 1.5' },
  { key: 'jardin', label: 'Jardin', icon: 'M12 6.5V7m0-.5a6 6 0 0 1 6-6h.5V7a6.5 6.5 0 0 1-6.5 6.5m0-7a6 6 0 0 0-6-6h-.5V7a6.5 6.5 0 0 0 6.5 6.5m0 0V23m0-9.5v9m0 1H7.5a6 6 0 0 1-6-6H6a6 6 0 0 1 6 6Zm0 0h4.5a6 6 0 0 0 6-6H18a6 6 0 0 0-6 6Z' },
  { key: 'piscine', label: 'Piscine', icon: 'M4 14c1.6.865 3.4.865 5 0c1.6-.864 3.4-.864 5 0c1.6.865 3.4.865 5 0m-15 6c1.6.865 3.4.865 5 0c1.6-.864 3.4-.864 5 0c1.6.865 3.4.865 5 0' },
  { key: 'tv', label: 'Téléviseur', icon: 'M4 19q-.825 0-1.412-.587T2 17V5q0-.825.588-1.412T4 3h16q.825 0 1.413.588T22 5v12q0 .825-.587 1.413T20 19h-4v1q0 .425-.288.713T15 21H9q-.425 0-.712-.288T8 20v-1zm0-2h16V5H4z' },
  { key: 'generator', label: 'Groupe électrogène', icon: 'M12 3c-1.27 0-2.4.8-2.82 2H3v2h1.95L2 14c-.47 2 1 3 3.5 3s4.06-1 3.5-3L6.05 7h3.12c.33.85 1.01 1.53 1.86 1.86v11.18c-.64.45-1.03 1.18-1.03 2V22h4v-.96c0-.82-.39-1.55-1.03-2V8.86c.85-.33 1.53-1.01 1.86-1.86h3.12L14.95 14c-.47 2 1.09 3 3.5 3s4-1 3.5-3L19 7h2V5h-6.18c-.42-1.2-1.55-2-2.82-2' },
  { key: 'washingMachine', label: 'Machine à laver', icon: 'M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m0 18H6V4h12zm-6-7a2 2 0 1 0 0-4a2 2 0 0 0 0 4' },
  { key: 'electricityClientCharge', label: 'Électricité client', icon: 'M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66c.19-.34.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21' },
  { key: 'iron', label: 'Fer à repasser', icon: 'M21 6c0-1.1-.9-2-2-2h-6.5l-1-1h-3l-1 1H1v2h2l1 18h16l1-18h2zM9.5 4h5l.5.5h-6zM4.94 22L4.06 6h15.88l-.88 16z' },
  { key: 'airConditioner', label: 'Climatiseur', icon: 'M6.59 3.41L2 8.01l4.59 4.59l1.06-1.06L4.12 8l3.53-3.54zM9 8.99h6v-2H9zm8.59-1.06l3.53 3.54l-3.53 3.53l1.06 1.06L23.06 11l-4.41-4.41zM15 7.99h-2V3h-2v5h-1v11h1v-4h4v-3h2V7.99z' },
  { key: 'fan', label: 'Ventilation', icon: 'M12 11a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2m-2 3v8h4v-8l4.27 2.47l1-1.73L12 8l-7.27 4.2l1 1.73z' },
  { key: 'partiesAllowed', label: 'Fêtes autorisées', icon: 'm5.8 21l1.6-7L2 9.2l7.2-.6L12 2l2.8 6.6l7.2.6l-5.4 4.8l1.6 7L12 17.3z' },
  { key: 'waterHeater', label: 'Chauffe-eau', icon: 'M12 6c-3.31 0-6 2.69-6 6c0 2.97 2.16 5.43 5 5.91V21h2v-3.09c2.84-.48 5-2.94 5-5.91c0-3.31-2.69-6-6-6m0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4s4 1.79 4 4s-1.79 4-4 4' },
  { key: 'extra.microwave', label: 'Micro-ondes', icon: 'M4 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 2h16v10H4z' },
  { key: 'extra.canal', label: 'Canal+', icon: 'M9 10v8l7-4zm12-4v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2m-2 0H5v12h14z' },
  { key: 'extra.netflix', label: 'Netflix', icon: 'M6.5 2h4l2.94 8.83L13.5 2h4v20c-1.25-.22-2.63-.36-4.09-.42L10.5 13l-.07 8.59c-1.4.06-2.73.2-3.93.41z' },
];

const getFeatureValue = (obj, path) => {
  const value = path.split('.').reduce((acc, key) => (acc ? acc[key] : undefined), obj);
  return value === true;
};

const activeHousingFeatures = computed(() => {
  return FEATURE_CONFIG.filter((feature) => getFeatureValue(apartment.value, feature.key));
});

const featureRows = computed(() => {
  const rows = [];
  for (let i = 0; i < activeHousingFeatures.value.length; i += 3) {
    rows.push(activeHousingFeatures.value.slice(i, i + 3));
  }
  return rows;
});

const fetchApartment = async () => {
  try {
    const response = await apiClient.get(`/apartments/${route.params.id}`);
    apartment.value = response.data;
  } catch (error) {
    console.error('Error fetching apartment:', error);
    apartment.value = {}; // S'assurer que apartment est vide en cas d'erreur
  } finally {
    loading.value = false;
  }
};

const formatPrice = (price) => {
  return new Intl.NumberFormat('fr-FR').format(price);
};

const showPhoto = (index) => {
  currentPhotoIndex.value = index;
  showAllPhotos.value = true;
};

const nextPhoto = () => {
  if (currentPhotoIndex.value < apartmentImages.value.length - 1) {
    currentPhotoIndex.value++;
  }
};

const prevPhoto = () => {
  if (currentPhotoIndex.value > 0) {
    currentPhotoIndex.value--;
  }
};

// Navigation tactile (swipe) pour mobile
let touchStartX = 0;
let touchStartY = 0;

const onTouchStart = (e) => {
  const touch = e.changedTouches[0];
  touchStartX = touch.clientX;
  touchStartY = touch.clientY;
};

const onTouchEnd = (e) => {
  const touch = e.changedTouches[0];
  const deltaX = touch.clientX - touchStartX;
  const deltaY = touch.clientY - touchStartY;
  // On ne réagit qu'aux glissements horizontaux suffisamment marqués
  if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) {
    if (deltaX < 0) {
      nextPhoto();
    } else {
      prevPhoto();
    }
  }
};

const downloadPhoto = (index) => {
  const file = apartmentImages.value[index];
  if (!file) return;
  downloadImage(`https://api.mohimmo.com/uploads/${file}`, file);
};

const downloadCurrentPhoto = () => {
  downloadPhoto(currentPhotoIndex.value);
};

const rentApartment = () => {
  router.push(`/apartments/${route.params.id}/reserve`)
};

const goBack = () => {
  router.back();
};

const copyToClipboardFallback = (text) => {
  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.style.position = 'fixed'
  document.body.appendChild(textarea)
  textarea.select()
  document.execCommand('copy')
  document.body.removeChild(textarea)
}

const shareApartment = async () => {
  const apt = apartment.value
  if (!apt || !apt._id) return

  const shareUrl = `${window.location.origin}/apartments/${apt._id}`
  const shareText = `Découvrez ce bien à ${apt.locality}: ${apt.title}`

  try {
    if (navigator.share) {
      await navigator.share({
        title: apt.title,
        text: shareText,
        url: shareUrl
      })
      return
    }

    if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      window.open(`whatsapp://send?text=${encodeURIComponent(shareText + '\n' + shareUrl)}`, '_blank')
    } else if (navigator.clipboard) {
      await navigator.clipboard.writeText(`${shareText}\n${shareUrl}`)
      toast.success('Lien copié dans le presse-papier !', {
        position: 'top-right',
        autoClose: 3000
      })
    } else {
      copyToClipboardFallback(`${shareText}\n${shareUrl}`)
      toast.success('Lien copié dans le presse-papier !', {
        position: 'top-right',
        autoClose: 3000
      })
    }
  } catch (err) {
    console.error('Erreur de partage:', err)
    toast.error('Échec du partage', {
      position: 'top-right',
      autoClose: 3000
    })
  }
}

onMounted(() => {
  fetchApartment();
});
</script>

<style scoped>
.degradeB {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
  pointer-events: none;
}

::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.parent {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

.parent::-webkit-scrollbar-track {
  background: transparent;
}
</style>
